import { render, staticRenderFns } from "./AlertWithIcon.vue?vue&type=template&id=a73a2006&scoped=true"
import script from "./AlertWithIcon.vue?vue&type=script&lang=js"
export * from "./AlertWithIcon.vue?vue&type=script&lang=js"
import style0 from "./AlertWithIcon.vue?vue&type=style&index=0&id=a73a2006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73a2006",
  null
  
)

export default component.exports